module.exports = __webpack_public_path__ + "od-chevron-down-thin-black-icon/od-chevron-down-thin-black-icon-a46e6cb30ee32c11b87f9155b872bf24.svg";